import React, { Component } from "react";
import Predefine_Colar_Cricket from "../components/Predefine_Colar_Cricket/Predefine_Colar_Cricket";

export class Predefine_Colar_CricketPage extends Component {
  render() {
    return <Predefine_Colar_Cricket />;
  }
}

export default Predefine_Colar_CricketPage;
